module.exports = __webpack_public_path__ + "static/img/plus.77b96a3a.svg";